/**
 * Fill the select options of the SportsData Search.
 * Add the `dependent select` behavior to the `competition`
 *  with respect to `sport`, and the `page` with respect to `competition`.
 * Add `redirect on change` behavior to `page select`.
 */
class Search {
  constructor(element$, {search}) {
    this.element$           = element$;
    this.config             = search;
    this.sportSelect$       = element$.find('[data-voc-sportsdata-search-sport]').removeAttr('disabled');
    this.competitionSelect$ = element$.find('[data-voc-sportsdata-search-competition]');
    this.pageSelect$        = element$.find('[data-voc-sportsdata-search-page]');

    // NOTE: Selects events
    this.sportSelect$.on('change', () => {
      this.fillCompetitionSelect();
      this.fillPageSelect();
      this.competitionSelect$.removeAttr('disabled');
    });
    this.competitionSelect$.on('change', () => {
      this.fillPageSelect();
      this.pageSelect$.removeAttr('disabled');
    });
    this.pageSelect$.on('change', (e) => {
      window.location = Voonto.$(e.target).val();
    });

    this.fillSelects();
  }

  buildOptionTemplate(value, name, selected) {
    return `<option value="${value}" ${(selected ? ' selected="selected"' : '')}>${name}</option>`;
  }

  fillSportSelect() {
    this.sportSelect$.find('option:not(:first)').remove();
    if (this.config.sports) {
      for (let sport in this.config.sports) {
        this.sportSelect$.append(this.buildOptionTemplate(sport, this.config.sports[sport]));
      }
    }
  }

  fillCompetitionSelect() {
    this.competitionSelect$.find('option:not(:first)').remove();
    var sportSelected = this.sportSelect$.val();
    if (this.config.competitions && this.config.competitions[sportSelected]) {
      var competitions = this.config.competitions[sportSelected];
      for(let competition in competitions) {
        this.competitionSelect$.append(this.buildOptionTemplate(competition, competitions[competition]));
      }
    }
  }

  fillPageSelect() {
    this.pageSelect$.find('option:not(:first)').remove();
    var competitionSelected = this.competitionSelect$.val();
    if (this.config.pages && this.config.pages[competitionSelected]) {
      var pages = this.config.pages[competitionSelected];
      for(let page in pages) {
        this.pageSelect$.append(this.buildOptionTemplate(pages[page].url, pages[page].name));
      }
    }
  }

  fillSelects() {
    this.fillSportSelect();
    this.fillCompetitionSelect();
    this.fillPageSelect();
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/views/search.js